/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";
const BASE_PATH = `${API_BASE_SRC}/contacto/empresas`;
export const CONSULTA_INDIVIDUO_NEGATIVO = `${BASE_PATH}/consultaIndividuoNegativo`;
export const GUARDAR_DATOS_CONTACTO = `${BASE_PATH}/guardarDatosContacto`;
